import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import useProfileStyles from './profileStyles';
import userApi from '../../Api/userApi';
import store from '../../redux/store';
import { changePreferences, updateUserConsent } from '../../redux/actions';
import { cx } from '../Home/HomeDashboard/dashboardStyles';

/** The email consent switches: news and special offers. */
const ChangePreferences = ({ profile }) => {
    const classes = useProfileStyles();
    const [marketing, setMarketing] = useState(false);
    const [specialOffers, setSpecialOffers] = useState(false);
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        if (!profile.consent) return;
        setMarketing(profile.consent.allowMarketing);
        setSpecialOffers(profile.consent.allowSpecialOffers);
    }, [profile.consent]);

    const updateConsent = (event) => {
        event.preventDefault();
        setLoading(true);
        setSaved(false);
        userApi
            .updateConsent({
                allowMarketing: marketing,
                allowSpecialOffers: specialOffers,
                terms: JSON.stringify('terms-20220504'),
                policy: JSON.stringify('policy-20220402'),
            })
            .then((response) => {
                store.dispatch(updateUserConsent(response.data));
                store.dispatch(changePreferences('CHANGE_PREFERENCES'));
                setLoading(false);
                setSaved(true);
            })
            .catch((err) => {
                console.error('unable to update consent', err);
                setLoading(false);
            });
    };

    return (
        <form className={classes.card} onSubmit={updateConsent}>
            <h2 className={classes.cardTitle}>
                <FormattedMessage id="profile.tab.updatePreferences" />
            </h2>
            <p className={classes.text}>
                <FormattedMessage id="redesign.profile.preferences.lead" />
            </p>
            {saved ? (
                <div className={cx(classes.notice, classes.noticeOk)} role="status">
                    <FormattedMessage id="redesign.profile.preferences.saved" />
                </div>
            ) : null}
            <div style={{ display: 'grid', gap: '10px', marginBottom: '18px' }}>
                <label className={classes.check}>
                    <input
                        type="checkbox"
                        checked={marketing}
                        onChange={(event) => setMarketing(event.target.checked)}
                    />
                    <FormattedMessage id="consent.dialog.checkbox.allowMarketing" />
                </label>
                <label className={classes.check}>
                    <input
                        type="checkbox"
                        checked={specialOffers}
                        onChange={(event) => setSpecialOffers(event.target.checked)}
                    />
                    <FormattedMessage id="consent.dialog.checkbox.allowSpecialOffers" />
                </label>
            </div>
            <div className={classes.actions}>
                <button type="submit" disabled={loading} className={classes.primary}>
                    <FormattedMessage id="consent.dialog.button.confirm" />
                    <span aria-hidden="true">→</span>
                </button>
            </div>
        </form>
    );
};

const mapStateToProps = (state) => {
    const { profile } = state;
    return { profile };
};

export default connect(mapStateToProps)(ChangePreferences);
